import { locate, getID } from "@xbs/lib-dom";
const mouseWaitBeforeDrag = 100;
const touchWaitBeforeDrag = 1500;
function preventClick(ev) {
    ev.preventDefault();
    window.removeEventListener("click", preventClick, true);
}
export function drag(node, config) {
    let dragItem;
    let calledBefore = false;
    let presed;
    let waitTimeout;
    let dragType;
    let dragInfo;
    let event;
    let startMouseEvent;
    function getNode(ev) {
        const { triggers } = config;
        let node;
        let attr = "data-id";
        if (triggers?.length) {
            for (let i = 0; i < triggers.length; i++) {
                attr = triggers[i];
                node = locate(ev, triggers[i]);
                if (node)
                    break;
            }
        }
        else {
            node = locate(ev);
        }
        return { node, attr };
    }
    function getNodeId(ev) {
        if (!ev)
            return;
        const { triggers } = config;
        let id;
        let attr = "data-id";
        if (triggers?.length) {
            for (let i = 0; i < triggers.length; i++) {
                attr = triggers[i];
                id = getID(ev, triggers[i]);
                if (id)
                    break;
            }
        }
        else {
            id = getID(ev);
        }
        return { id, attr };
    }
    function mousedown(ev, touch = false) {
        if (config.skip)
            return;
        const nodeData = getNode(ev);
        const node = nodeData.node;
        const drag_atr = node?.getAttribute("data-drag");
        if (!node || !drag_atr || drag_atr === "target")
            return false;
        if (ev.button !== 0)
            return false; // start dnd on left mouse button click only
        startMouseEvent = ev;
        ev.preventDefault();
        presed = setTimeout(() => {
            dragItem = node;
            window.addEventListener("mousemove", mousemove);
            window.addEventListener("touchmove", mousemove, {
                passive: false,
            });
            presed = null;
        }, touch ? touchWaitBeforeDrag : mouseWaitBeforeDrag);
        window.addEventListener("mouseup", mouseup);
        window.addEventListener("touchend", mouseup);
    }
    function mousemove(ev) {
        ev.preventDefault();
        const { dragCreate, dragResize, dragMove, model, dispatch, popupInfo } = config;
        const { getEventFromPosition, updateEventPosition } = model;
        if (!calledBefore) {
            window.addEventListener("click", preventClick, true);
            const node = getNode(dragItem).node;
            const { id, attr } = getNodeId(dragItem);
            if (attr === "data-cell") {
                dragType = "add";
                if (!dragCreate)
                    return;
                if (!config.calendars.length) {
                    dispatch("action", {
                        action: "add-calendar",
                        data: {
                            calendar: {
                                label: "New calendar",
                            },
                        },
                    });
                }
            }
            else {
                if (attr === "data-resizer" && !dragResize)
                    return;
                dragType = "resize";
                if (attr === "data-resizer") {
                    node.style.visibility = "visible";
                }
                if (attr === "data-id" && node) {
                    dragType = "update";
                    if (!dragMove)
                        return;
                    document.body.style.cursor = "pointer";
                    const { top, height } = node.getBoundingClientRect();
                    const y = startMouseEvent.clientY - top;
                    const bottom = top + height - startMouseEvent.clientY;
                    dragInfo = { top: y, bottom };
                }
            }
            event = getEventFromPosition(id, attr, startMouseEvent, config.locale);
            calledBefore = true;
        }
        if (ev.touches) {
            const { clientX, clientY } = ev.touches[0];
            ev.clientX = clientX;
            ev.clientY = clientY;
        }
        if (!event)
            return;
        updateEventPosition(event, ev, dragInfo, dragType);
        if (popupInfo) {
            dispatch("action", { action: "close-event-info" });
        }
    }
    function mouseup() {
        window.removeEventListener("mousemove", mousemove);
        window.removeEventListener("mouseup", mouseup);
        window.removeEventListener("touchmove", mousemove);
        window.removeEventListener("touchend", mouseup);
        document.body.style.cursor = "default";
        clearTimeout(waitTimeout);
        if (presed) {
            clearTimeout(presed);
            return;
        }
        calledBefore = false;
        const { dispatch } = config;
        if (!event)
            return;
        const updatedEvent = event.eventData;
        if (dragType === "resize") {
            const node = locate(dragItem, "data-resizer");
            node.style.visibility = "initial";
        }
        dragType = dragType === "add" ? dragType : "update";
        if (dragType === "add") {
            dispatch("action", {
                action: `edit-event`,
                data: {
                    add: updatedEvent,
                },
            });
        }
        else {
            dispatch("action", {
                action: `update-event`,
                data: {
                    event: updatedEvent,
                    id: updatedEvent.id,
                },
            });
        }
        event = dragInfo = startMouseEvent = null;
    }
    node.addEventListener("mousedown", mousedown);
    return {
        update: (nextConfig) => (config = nextConfig),
    };
}
//# sourceMappingURL=drag.js.map